import { useMemo } from 'react';

export const useCompanyId = (authCompanyId: number | string | null | undefined): number | null => {
  return useMemo(() => {
    const rawCompanyId = authCompanyId;
    const parsed = Number(rawCompanyId);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  }, [authCompanyId]);
};
